import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Grid } from '@mui/material'

import AutoComplete from '../AutoComplete'
import { useSelectionSet } from '../../hooks/selection-set-functions'
import { groupByGirone, getArePubblicati } from '../../hooks/utils-functions'
import { useGetIscrizioniQuery } from '../../hooks/api-slice'

const SelectTeam = () => {
  const { admin } = useSelector(state => state.home.infoUtente)
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )
  const availableTeams = useSelector(state => state.selection.availableTeams)
  const selectedTeam = useSelector(state => state.selection.selectedTeam)
  const selectedCampionatoGironiPubblicati = useSelector(
    state => state.selection.selectedCampionatoGironiPubblicati,
  )
  const selectedCampionatoCalendariPubblicati = useSelector(
    state => state.selection.selectedCampionatoCalendariPubblicati,
  )

  const location = useLocation()
  const arePubblicati = getArePubblicati(
    selectedCampionatoGironiPubblicati,
    selectedCampionatoCalendariPubblicati,
    location.pathname?.split('/')?.[1],
  )

  const { data: iscrizioniLight } = useGetIscrizioniQuery(
    { campionato: selectedCampionato, iFilter: 'light' },
    { skip: !(selectedCampionato && (admin || arePubblicati)) },
  )

  const { setSelectedGirone, setSelectedTeam } = useSelectionSet()

  const options = availableTeams?.filter(t =>
    iscrizioniLight?.map(i => i.id)?.includes(t?.id),
  )

  const getOptionLabel = op =>
    iscrizioniLight?.find(i => i?.id === (op?.id || op))?.nomeSquadra || op?.id

  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <AutoComplete
        id='available-teams'
        label='Squadra'
        value={selectedTeam}
        options={options}
        groupBy={groupByGirone}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(op, value) => op?.id === value}
        disabled={!availableTeams || (!admin && !arePubblicati)}
        onChange={i => {
          if (i?.id) setSelectedGirone(i?.girone)
          setSelectedTeam(i?.id)
        }}
      />
    </Grid>
  )
}

export default SelectTeam
